import { slide, type SlideParams, type TransitionConfig } from "svelte/transition";

export function fadeSlide(node: Element, options?: SlideParams | undefined): TransitionConfig {
  const slideTrans = slide(node, options);
  return {
    easing: options?.easing,
    duration: options?.duration,
    css: (t: number) => `
      ${slideTrans.css && slideTrans.css(t, 0)}
      opacity: ${t};
    `,
  };
}
